export const validateLength = (answer) => {
    if (!answer) {
        return false;
    } else {

        //Calendar is an array be default and has a length of zero, so check for this
        if (Array.isArray(answer) && answer.length === 0) {
            return false;
        }

        //Otherwise check the object
        for (var child in answer) {
            if (answer.hasOwnProperty(child)) {
                var propertyValue = answer[child];
                if (propertyValue === null) {
                    return false;
                }
            }
        }
    }
    return true;
}